import _extend from 'lodash/extend';
import Utils from 'services/utils';
import Config from 'services/config/local';

/**
 * Event class.
 */
export default class Event {
    /**
     * @param {Object} data - Event data
     * @constructor
     */
    constructor(data) {
        _extend(this, data);

        this.createdFormatted = Utils.convertTimestampToFormat(this.created, Config.format.datetime);
    }
}



// WEBPACK FOOTER //
// ./app/services/api/events/event.class.js